import accountingReducer, * as fromAccounting from './reducers/accounting.reducers';
import authReducer, * as fromAuth from './reducers/auth.reducers';
import errorReducer, * as fromError from './reducers/error.reducers';
import menuItemReducer, * as fromMenuItem from './reducers/menuIterm.reducers';
import profileReducer, * as fromProfile from './reducers/profile.reducers';
import searchReducer, * as fromSearch from './reducers/search.reducers';
import supportReducer, * as fromSupport from './reducers/support.reducers';
import tallenesTaleReducer, * as fromTallenesTale from './reducers/tallenesTale.reducers';
import transReducer, * as fromTrans from './reducers/trans.reducers';
import uiReducer, * as fromUI from './reducers/ui.reducers';
import userAdminReducer, * as fromUserAdmin from './reducers/userAdmin.reducers';
import utilsReducer, * as fromUtils from './reducers/utils.reducers';
import NN05Reducer, * as fromNN05 from './reducers/NN05.reducers';
import NV05Reducer, * as fromNV05 from './reducers/NV05.reducers';
import NV04Reducer, * as fromNV04 from './reducers/NV04.reducers';
import NV03Reducer, * as fromNV03 from './reducers/NV03.reducers';
import NO01Reducer, * as fromNO01 from './reducers/NO01.reducers';
import NV02Reducer, * as fromNV02 from './reducers/NV02.reducers';
import NV01SALGReducer, * as fromNV01SALG from './reducers/NV01.reducers';
import NO03Reducer, * as fromNO03_INVOICE from './reducers/NO03.reducers';
import NV06Reducer, * as fromNV06 from './reducers/NV06.reducers';
import NO04OrdreReducer, * as fromNO04Ordre from './reducers/NO04.reducers';
import NO05AapneOrdreReducer, * as fromNO05AapneOrdre from './reducers/NO05.reducers';
import NR01Reducer, * as fromNR01 from './reducers/NR01.reducers';

/**
 * Root reducer object containing all application reducers.
 */
const rootReducer = {
  auth: authReducer,
  profile: profileReducer,
  utils: utilsReducer,
  support: supportReducer,
  accounting: accountingReducer,
  menuItem: menuItemReducer,
  search: searchReducer,
  ui: uiReducer,
  trans: transReducer,
  error: errorReducer,
  userAdmin: userAdminReducer,
  tallenesTale: tallenesTaleReducer,
  NN05: NN05Reducer,
  NV05: NV05Reducer,
  NV03: NV03Reducer,
  NO01: NO01Reducer,
  NV02: NV02Reducer,
  NV01SALG: NV01SALGReducer,
  NV04: NV04Reducer,
  NO03: NO03Reducer,
  NV06: NV06Reducer,
  NO04Ordre: NO04OrdreReducer,
  NO05AapneOrdre: NO05AapneOrdreReducer,
  NR01: NR01Reducer,
};

export default rootReducer;

export type AppState = {
  auth: fromAuth.StateAuthCred;
  profile: fromProfile.StateProfile;
  utils: fromUtils.StateUtils;
  accounting: fromAccounting.StateAccounting;
  menuItem: fromMenuItem.StateMenuItem;
  search: fromSearch.StateSearch;
  ui: fromUI.StateUI;
  trans: fromTrans.StateTrans;
  error: fromError.StateError;
  userAdmin: fromUserAdmin.StateUserAdmin;
  tallenesTale: fromTallenesTale.STALE;
  NN05: fromNN05.NN05;
  NV05: fromNV05.NV05;  
  NV04: fromNV04.NV04State;
  NV03: fromNV03.NV03;
  NO01: fromNO01.NO01;
  NV02: fromNV02.NV02;
  NV01SALG: fromNV01SALG.NV01SALG;
  support: fromSupport.StateSupport;
  NO03: fromNO03_INVOICE.NO03State;
  NV06: fromNV06.NV06State;
  NO04Ordre: fromNO04Ordre.NO04State;
  NO05AapneOrdre: fromNO05AapneOrdre.NO05State;
  NR01: fromNR01.NR01State;
};